export default 'https://bdauth-mch.zjhejiang.com'
